// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/ground-air-signals.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/ground-air-signals/ground-air-signals.js';

mount([g0]);
